// extracted by mini-css-extract-plugin
module.exports = {"container":"styles__container___3oPmV","title":"styles__title___3elRj","description":"styles__description___2Pmyd","icon":"styles__icon___IJDc1","action":"styles__action___35Mt1"};